import { clientConfig } from '../config';

/**
 * Checks if tickets should be hidden based on PARQ requirements.
 * @param {Object} event - The event object.
 * @param {Object} coworker - The coworker object.
 * @param {boolean} hasValidGymWaiver - The status of the gym waiver.
 * @returns {boolean} - Returns true if tickets should be hidden, false otherwise.
 */
export const checkHideTickets = (event, coworker, hasValidGymWaiver) => {
  const config = clientConfig();
  const requiresPARQ = event.EventCategories?.some(
    (e) => e.Id == config.gymEventId,
  );

  // Never hide tickets for non-gym events
  if (!requiresPARQ) {
    return false;
  }

  // For gym events, hide if no valid waiver or no PARQ
  if (!hasValidGymWaiver) {
    return true;
  }

  return false;
};
